<template>
    <teleport to="head">
        <meta name="title" :content="entry.title"/>
        <meta name="description" :content="entry.description"/>
    </teleport>
    <div class="post-outer-wrap">
        <div class="post-wrap">
            <h1>{{entry.title}}</h1>
            <div class="article-meta">
                <p><small>{{entry.date}}</small></p>
                <p><small><fa-icon :icon="['fas', 'tag']"/> {{entry.tags}}</small></p>
            </div>
            <component v-if="finishedLoading" :is="component"></component>
        </div>
    </div>
</template>

<script>
    import buildBlogSlug from '@/helpers/buildBlogSlug'
    import 'highlight.js/styles/atom-one-dark.css';
    export default {
        name: "BlogProjectsSingle",
        components: {
        },
        data () {
            return {
                component: 'SingleBlog',
                finishedLoading: false,
                entry: {},
            } 
        },
        watch: {
            $route(to, from) {
                this.loadDynamicComponent()
                this.loadEntry()
            }
        },
        computed: {
            postSlug () {
                return this.$route.params.slug
            },
            thing () {
                return 'LostAndFound'
            }
        },
        methods: {
            loadDynamicComponent () {
                if (!this.postSlug) return;
                import('@/markdown/' + this.postSlug + '.md')
                    .then(component => {
                        this.$options.components[this.component] = component.default
                        this.finishedLoading = true
                    })
                    .catch(e => {
                        this.$router.push({
                            name: 'LostAndFound'
                        })
                    })
            },
            loadEntry () {
                import('@/data/BlogEntries.json')
                    .then(({ default: entries }) => {
                        this.entry = entries.find(entry => {
                            return buildBlogSlug(entry) === this.postSlug
                        }) || {}
                    })
            }
        },
        mounted () {
            this.loadDynamicComponent()
            this.loadEntry()
        }
    }
</script>

<style lang="scss">
    .post-outer-wrap {
        background: #222222;

        .post-wrap {
            background: white;
            margin: auto;
            max-width: 850px;
            padding: 15px 15px 50px 15px;

            .article-meta {
                p { margin: 0;}
            }

            p, li {
                line-height: 1.6em;
                font-size: 1.1em;
            }
        }
    }
</style>